export interface IWhatsappSharePayload {
  message: string;
  idempotency_key: string;
}

interface IWhatsappShareLogResponse {
  success?: boolean;
}

export function ensureWhatsappShareLogged<T extends IWhatsappShareLogResponse>(response: T): T {
  if (!response?.success) {
    throw new Error('WhatsApp share logging failed');
  }

  return response;
}

export function getWhatsappMessageFromUrl(whatsappUrl?: string): string {
  if (!whatsappUrl) {
    return '';
  }

  try {
    return new URL(whatsappUrl).searchParams.get('text') || '';
  } catch {
    return '';
  }
}

export function withWhatsappMessage(whatsappUrl: string, message: string): string {
  try {
    const url = new URL(whatsappUrl);
    url.searchParams.set('text', message);
    return url.toString();
  } catch {
    return whatsappUrl;
  }
}

export function buildWhatsappSharePayload(invitationId: number, message: string): IWhatsappSharePayload {
  return {
    message,
    idempotency_key: `share-${invitationId}-${Date.now()}-${Math.random().toString(36).slice(2)}`
  };
}
